<template>
  <div>
    <a href="http://novolife.tsyungu.com/brain4">
      <v-img :src="require('../assets/intro1.jpg')"></v-img>
    </a>
    <div style="background-color: #eeffff">
      <v-container style="max-width: 1200px">
        <v-row>
          <v-col cols="3" style="display: flex;justify-content: center">
            <router-link to="/intro2"><img :src="require('../assets/title1.png')"></router-link>
          </v-col>
          <v-col cols="3" style="display: flex;justify-content: center">
            <router-link to="/intro3"><img :src="require('../assets/title2.png')" ></router-link>
          </v-col>
          <v-col cols="3" style="display: flex;justify-content: center">
            <router-link to="/intro4"><img :src="require('../assets/title3.png')" ></router-link>
          </v-col>
          <v-col cols="3" style="display: flex;justify-content: center">
            <router-link to="/intro5"><img :src="require('../assets/title4.png')"></router-link>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container style="max-width: 1200px">
      <v-row>
        <v-col cols="12">
          <p>
            睿米（Remebot）神经外科手术机器人历经二十年自主研发和上万例临床试验，是国内第一个成功应用于临床、第一个实现远程手术、
            第一个获得NMPA认证的国产神经外科手术机器人，是国内乃至手术机器人全行业的领军者。
          </p>
          <p style="text-align: center">
            <img :src="require('../assets/intro4-1.png')" alt="">
          </p>
          <p>
            睿米机器人借助医学影像扫描、三维可视化、多模态影像融合、精准规划穿刺路径等技术，避免传统开颅手术所造成的创伤，
            可针对颅内病变神经核团进行精准的调控和修复、建立新的生理平衡。整个手术平均用时30分钟，定位精度达0.5毫米，创口仅2毫米，术后观察2至3天即可出院，拥有微创、精准、高效的特点。
          </p>
        </v-col>
      </v-row>
    </v-container>

    <v-img :src="require('../assets/intro2.jpg')"></v-img>
  </div>
</template>

<script>
export default {
  name: "Intro4"
}
</script>

<style scoped>
p {
  font-family: "Microsoft YaHei","黑体", Helvetica, Arial, sans-serif;
  text-indent: 2em;
  font-size: 18px;
}
</style>
